import { render, staticRenderFns } from "./Loadingcircle.vue?vue&type=template&id=3bbefa0b"
import script from "./Loadingcircle.vue?vue&type=script&lang=js"
export * from "./Loadingcircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports